export default {
  title: {
    home: 'Inicio',
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar'
    },
    label: {},
    placeholder: {}
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe'
  },
  success: {},
  cookieLaw: {
    text:
      'Utilizamos cookies propias y de terceros para realizar análisis de uso y de medición de nuestra web para mejorar nuestros servicios. Si continuas navegando, consideramos que aceptas su uso. Puedes cambiar la configuración u obtener más información aquí:',
    goToText: 'Política de cookies',
    buttonText: 'Aceptar'
  }
};
